import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { routesConfig } from '../routes/routesConfig';

const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    // Find the matching route
    const currentRoute = routesConfig.find(route => route.path === location.pathname);
    
    let pageTitle = 'TradeLyft';
    
    if (currentRoute && currentRoute.label) {
      pageTitle = `${currentRoute.label} - TradeLyft`;
    } else if (location.pathname === '/') {
      pageTitle = 'Order Book - TradeLyft';
    } else if (location.pathname === '/login') {
      pageTitle = 'Sign in - TradeLyft';
    } else if (location.pathname === '/un-authorized') {
      pageTitle = 'Unauthorized - TradeLyft';
    } else if (location.pathname === '/select-broker') {
      pageTitle = 'Connect broker - TradeLyft';
    } else {
      pageTitle = 'Not Found - TradeLyft';
    }
    
    document.title = pageTitle;
  }, [location.pathname]);
};

export default usePageTitle;

